module.exports = __webpack_public_path__ + "img/arrow-right.ec7c1a7b.svg";